import React, { useState, useEffect } from "react";
import axios from "axios";
import { useHistory, useLocation, Redirect } from 'react-router-dom';
import { TicketFilters, TicketPriority, TicketQueues } from "helpers/Enums";
import { Dictionary } from "lodash";

interface ICustomerTicketsContext {
    recordCount: number
    search: ISearch
    tickets: ITicket[]
    isLoading: boolean

    updateSearch: (newSearch: ISearch) => void
    doSearch: (search: ISearch) => void,
    handleChangePage: (event: any, page: number) => void
}

export interface ITicket {
    ticketId: string
    number: string
    title: string
    categoryId: string
    ticketSubCategoryId: string
    ticketPriority: TicketPriority
    customerName: string
    ticketStatus: Dictionary<string>
    assigneeUser: string
}

interface ISearch {
    searchText: string
    filter: string
    pageNr: number
    pageSize: number
}

export let customerTicketsContext = React.createContext<ICustomerTicketsContext>({} as ICustomerTicketsContext);

let { Provider } = customerTicketsContext;

export let CustomerTicketsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    let history = useHistory();
    let location = useLocation();

    let [isLoading, setLoading] = useState(true);
    let [tickets, setTickets] = useState<ITicket[]>([]);
    let [recordCount, setTotalRecords] = useState(0);
    let [search, setSearch] = useState<ISearch>({
        pageNr: 0,
        pageSize: 20,
        searchText: '',
        filter: "Open"
    });

    useEffect(() => {
        if (location.state)
            processState(location.state);

    }, [location.state])


    if (!location.state)
        return <Redirect to={{ pathname: location.pathname, state: { search } }} />


    let processState = (state: any) => {
        if (state.search) {
            let request = {
                ...state.search
            };

            setSearch(request);
            searchTickets(request);
        }
    }

    let doSearch = (values: ISearch) => {
        let request = {
            ...values,
            pageNr: values.pageNr > 0 ? 0 : values.pageNr
        }

        history.push(location.pathname, { search: request });
    }

    let updateSearch = (newSearch: ISearch) => {
        setSearch(newSearch);
    }

    let searchTickets = async (searchRequest: ISearch) => {
        try {
            setLoading(true);

            let response = await axios.post('/api/CustomerTicket/SearchTickets', searchRequest);
            setTickets(response.data.items);
            setTotalRecords(response.data.recordCount);

        } catch (error) { }
        finally {
            setLoading(false);
        }
    }

    let handleChangePage = (event: any, page: number) => {
        let request = {
            ...search,
            pageNr: page
        }

        window.scrollTo(0, 0);
        history.push(location.pathname, { search: request });
    }


    return (
        <Provider value={{
            recordCount,
            search,
            tickets,
            isLoading,

            updateSearch,
            doSearch,
            handleChangePage
        }}>
            {children}
        </Provider>
    );
};